import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { Searchbar, useTheme } from 'react-native-paper';
import { useDebounce } from '@coffeeplexity/shared';

export interface CreatorSearchProps {
  onSearchChange: (query: string) => void;
  onSpecialtyFilter: (specialty: string) => void;
  selectedSpecialty: string;
  searchQuery: string;
}

export function CreatorSearch({
  onSearchChange,
  searchQuery,
}: CreatorSearchProps) {
  const theme = useTheme();
  const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);

  const debouncedSearch = useDebounce(localSearchQuery, 300);

  useEffect(() => {
    onSearchChange(debouncedSearch);
  }, [debouncedSearch, onSearchChange]);

 

  const handleSearchChange = (query: string) => {
    setLocalSearchQuery(query);
  };

  

  return (
    <View style={styles.container}>
      <Searchbar
        placeholder='Search creators...'
        onChangeText={handleSearchChange}
        value={localSearchQuery}
        style={[styles.searchBar, { backgroundColor: theme.colors.surface }]}
        iconColor={theme.colors.onSurfaceVariant}
        inputStyle={styles.searchInput}
      />

  
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 8,
  },
  searchBar: {
    marginHorizontal: 16,
    marginVertical: 8,
    elevation: 2,
    height: 52,
    borderRadius: 12,
  },
  searchInput: {
    fontSize: 16,
  },
  filtersContainer: {
    marginVertical: 8,
    flexShrink: 0,
    flexGrow: 0,
    overflow: 'visible',
  },
  filtersContent: {
    paddingHorizontal: 16,
    gap: 8,
    alignItems: 'center',
  },
  chipWrapper: {
    flexShrink: 0,
    overflow: 'visible',
  },
  filterChip: {
    marginRight: 8,
    height: 40,
    borderRadius: 20,
    paddingHorizontal: 12,
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
